type NestedPJSO = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: NestedPJSO | any;
};

export const mergeDeep = (obj1: NestedPJSO, obj2: NestedPJSO): NestedPJSO => {
  if (!obj1) {
    return obj2;
  }
  if (!obj2) {
    return obj1;
  }
  const result = { ...obj2 };

  Object.keys(obj1).forEach((key): void => {
    const prop1 = obj1[key];
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      const prop2 = obj2[key];
      if (Array.isArray(prop1) && Array.isArray(prop2)) {
        result[key] = [...prop1, ...prop2];
      } else if (
        typeof prop1 !== 'string' &&
        typeof prop1 === 'object' &&
        typeof prop2 === 'object'
      ) {
        result[key] = mergeDeep(prop1, prop2);
      }
    } else {
      result[key] = prop1;
    }
  });
  return result;
};
